import React from "react";
import {Link} from "react-router-dom";
import moadian from '../../images/moadian.jpg';
import salary from '../../images/salary.jpg';
import othernotification from '../../images/othernotification.jpg';

function CardsEtelaieh() {


return(



    <section className="section  boder-top" >
<div className="container">
   <div className="row">

    <div className="col-md-12 mb-4 text-center">
     <h3 className="main-heading "> اطلاعیه ها </h3>
     <div className="underline mx-auto"> </div>
    </div>





    <div className="col-md-4 ">
    <div className="card shadow"></div>
    <img src={moadian}  width="200" height="250"  className="w-100 border-bottom" alt="moadian" />
    <div className="card-body"></div>
    <h6 className="mt-2">سامانه مودیان</h6>
    <div className="underline"></div>
    <p>
    سامانه مودیان  به منظور تسهیل فرآیند ثبت و مدیریت اطلاعات مالیاتی مودیان ایجاد شده است. نرم‌افزار حسابداری راینو به‌طور کامل از این سامانه پشتیبانی می‌کند و به کاربران این امکان را می‌دهد تا به راحتی اطلاعات مالیاتی خود را ثبت و ارسال کنند.

برای دریافت آخرین اخبار و اطلاعیه‌ها در مورد سامانه مودیان و تغییرات مرتبط، می‌توانید اینجا را دنبال کنید. با ما همراه باشید تا از اطلاعات و به‌روزرسانی‌های مهم مطلع شوید!      
    </p>
    <Link to="/Notifications" className="btn btn-link">اطلاعات بیشتر</Link>
    </div>





    <div className="col-md-4 ">
    <div className="card shadow"></div>
    <img src={salary} width="200" height="250"  className="w-100 border-bottom" alt="salary" />
    <div className="card-body"></div>
    <h6 className="mt-2">سیستم حقوق دستمزد</h6>
    <div className="underline"></div>
    <p>
    سیستم حقوق و دستمزد ابزاری کلیدی برای مدیریت دقیق حقوق و مزایای کارکنان است. نرم‌افزار حسابداری راینو به‌خوبی از خروجی‌های استاندارد پشتیبانی می‌کند، به‌طوری‌که کاربران می‌توانند به راحتی محاسبات حقوق را انجام دهند و گزارش‌های مورد نیاز را تولید کنند.

این ویژگی‌ها به سازمان‌ها کمک می‌کند تا فرآیندهای مالی و اداری خود را به‌طور مؤثرتری مدیریت کنند. برای دریافت آخرین اخبار و اطلاعیه‌ها در مورد سیستم حقوق و دستمزد و به‌روزرسانی‌های مربوطه، می‌توانید اینجا را دنبال کنید!       
    </p>
    <Link to="/Notifications" className="btn btn-link">اطلاعات بیشتر</Link>
    </div>




    <div className="col-md-4 ">
    <div className="card shadow"></div>
    <img src={othernotification}  width="200" height="250"  className="w-100 border-bottom" alt="othernotification" />
    <div className="card-body"></div>
    <h6 className="mt-2">سایر اطلاعیه ها</h6>
    <div className="underline"></div>
    <p>
    نرم‌افزار حسابداری راینو با ارائه قابلیت‌های جامع و کاربرپسند، به کاربران کمک می‌کند تا امور مالی خود را به‌طور مؤثری مدیریت کنند و گزارش‌های دقیق و به‌روزی از وضعیت مالی خود داشته باشند.

برای دریافت آخرین اخبار و اطلاعیه‌ها در مورد نرم‌افزار و به‌روزرسانی‌های آن، می‌توانید اینجا را دنبال کنید! با ما همراه باشید تا از جدیدترین اطلاعات و راهکارها بهره‌مند شوید.     
    </p>
    <Link to="/Notifications" className="btn btn-link">اطلاعات بیشتر</Link>
    </div>





   </div>
</div>

</section>



)


}


export default CardsEtelaieh;